<template>
  <svg style="width:24px;height:24px" viewBox="0 0 329.954 329.954">
      <path d="M99.85,299.045c2.813,2.813,6.629,4.393,10.607,4.393c3.979,0,7.794-1.581,10.606-4.393L325.56,94.548  c2.814-2.813,4.394-6.628,4.394-10.606c0-3.979-1.58-7.794-4.394-10.607l-42.427-42.426c-5.857-5.857-15.355-5.858-21.213,0  L110.461,182.37l-42.428-42.428c-2.813-2.813-6.629-4.394-10.607-4.394s-7.793,1.581-10.606,4.394L4.393,182.369  c-5.857,5.858-5.857,15.355,0,21.213L99.85,299.045z" />
  </svg>
</template>

<script>
  export default {
    
  }
</script>
